import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../firebase";
import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";
import handleErrorLandings from "../handleErrorLandings";
import ClaimBenefitsStep from "./ClaimsBenefits";

const landingId = "CF_CLAIMS_BENEFITS";

const onLoad = async ({ session, landedAt, uid, navigate }) => {
  try {
    const prevAnswers = {};
    const claimsCollection = collection(db, `users/${uid}/claims`);
    const claimsSnapshot = await getDocs(claimsCollection);
    const prevForm = await getFormSession(
      "cancelation-form",
      session.sessionID
    );
    const landings = prevForm.items;
    landings.forEach((item) => {
      if (item?.answers?.length > 0) {
        const lastField = item.answers[0];
        const fieldID = lastField.field.id;
        const lastFieldType = lastField.type;
        const lastFieldAnswers = lastField[lastFieldType]?.value;
        prevAnswers[fieldID] = lastFieldAnswers;
      }
    });

    const getMovements = async (claimRef) => {
      const movementsCollectionRef = collection(
        db,
        `${claimRef.path}/movements`
      );
      const movementsQuery = query(
        movementsCollectionRef,
        where("deleted", "==", false)
      );
      const movementsSnapshot = await getDocs(movementsQuery);

      let expenses = 0;
      let deductible = 0;
      let incomes = 0;

      movementsSnapshot.forEach((doc) => {
        const data = doc.data();
        const { amount, type } = data;
        if (type === "Gastos") expenses += amount;
        if (type === "Ingreso") incomes += amount;
        if (type === "Deducible") deductible += amount;
      });

      return { expenses, deductible, incomes };
    };

    const claimsPromises = claimsSnapshot.docs.map(async (claim) => {
      const claimData = claim.data();
      if (!claimData.isMock && !claimData.deleted && claim.ref) {
        const type = claimData.type[0];
        const { expenses, deductible, incomes } = await getMovements(claim.ref);
        const expensesSet = type === "vialAssistance" ? 2000 : expenses;
        const totalAmount = expensesSet - deductible - incomes;
        if (totalAmount === 0) {
          return null;
        }

        const isAVialAssistance = type === "vialAssistance";
        const titles = {
          vialAssistance: "Asitencia Vial",
          vehicleAccident: "Accidente de vehículo",
          carTheft: "Robo de auto",
          personalAccident: "Accidente personal",
          cellphoneTheft: "Robo de celular",
          "screen-breakage": "Rotura de pantalla",
          breakdown: "Falla o Descompostura",
          "accidental-damage": "Daños varios",
          tire: "Asitencia Vial - Cambio de llanta",
          locksmith: "Asitencia Vial - Cerrajero",
          battery: "Asitencia Vial - Corriente",
          gasoline: "Asitencia Vial - Gasolina",
          tow: "Asitencia Vial - Grúa",
        };
        return {
          id: claim.id,
          expenses: expensesSet,
          deductible,
          incomes,
          type,
          typeAccident: claimData.typeAccident,
          vehicle: claimData.vehicle,
          finalConclusion: claimData.finalConclusion,
          accidentTimestamp: claimData.accidentTimestamp,
          claimLevel: claimData.level,
          title: titles[isAVialAssistance ? claimData.assistanceType : type],
          assistanceType: claimData.assistanceType,
          isAVialAssistance,
          totalAmount,
        };
      }
      return null;
    });

    const claims = await Promise.all(claimsPromises);
    const validClaims = claims.filter((claim) => claim !== null);

    if (validClaims.length === 0) {
      navigate(`/formulario/cancelacion/servicio?uid=${uid}`);
    }

    return {
      userId: uid,
      ...prevAnswers,
      landedAt,
      prevForm,
      claims: validClaims,
      currentLanding: landingId,
    };
  } catch (error) {
    await handleErrorLandings({
      error,
      landingId,
      navigate,
      navigatePath: `/formulario/cancelacion/servicio?uid=${uid}`,
      message: `[Error Fomulario Cacelación] [Claims Benefits] Ocurrio un error al pedir la información\nlandingError: ${landingId}\nUID: ${uid}\nSessionID: ${session.sessionID}`,
    });
  }
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
  prevForm,
}) => {
  if (session?.sessionID) {
    try {
      await saveNotAnswersLanding({
        landingId,
        state,
        sessionID: session.sessionID,
        prevForm: state.prevForm,
      });
      if (nextPage) navigate(nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <ClaimBenefitsStep state={state} setState={setState} />
);

const nextPage = (props) => `/formulario/cancelacion/servicio?uid=${props.uid}`;
const prevPage = (props) =>
  `/formulario/cancelacion/beneficios?uid=${props.uid}`;

const fieldsStructure = [];

const claimsBenefitsProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default claimsBenefitsProps;
